import React from 'react';
import { Modal, } from 'antd';
import { ModalHeading, ModalSubTitle } from 'components/Typography';
import { useHistory } from 'react-router-dom';
import { Button } from 'components/Button';
import { InfoCircleOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';

const formatBytes = (bytes) => {
    const mb = bytes / 1024 / 1024;
    return mb >= 1024 ? `${(mb / 1024).toFixed(2)} GB` : `${mb.toFixed(2)} MB`;
};

const AulasSubscriptionModal = ({ isModalVisible, handleCancel, fromSchedule, user, availableStorageBytes }) => {
    const history = useHistory();
    const isSuperAdmin = user?.privilage?.includes('SuperAdmin');
    const isStorageVariant = availableStorageBytes !== undefined && availableStorageBytes !== null;
    const handleUpgrade = () => {

        history.push(fromSchedule ? '/broadcast-packages' : '/digital-library/buy-storage');
        handleCancel();
    };

    return (
        <Modal
            centered
            className="modal-round-corner subscription-modal"
            visible={isModalVisible}
            onCancel={handleCancel}
            footer={null}
            width={500}
        >
            <div className="subscription-content" style={{ textAlign: 'center', padding: '20px 10px' }}>
                {/* <div className="lock-icon" style={{ marginBottom: '20px' }}>
                    🔒
                </div> */}

                <ModalHeading style={{
                    fontSize: '24px',
                    marginBottom: '15px',
                    color: '#333'
                }}>
                    {isStorageVariant ? 'Storage Limit Reached' : 'Storage Full!'}
                </ModalHeading>

                <ModalSubTitle style={{
                    fontSize: '16px',
                    color: '#666',
                    marginBottom: '25px',
                    lineHeight: '1.5'
                }}>
                    {isStorageVariant ? (
                        <>You only have <strong>{formatBytes(availableStorageBytes)}</strong> of storage available, which isn't enough for this upload.
                            Upgrade your storage plan to continue.</>
                    ) : (
                        <>If you wish to upload more content, you can either free up some space or buy more storage. You can however continue to upload YouTube links.</>
                    )}
                </ModalSubTitle>

                {!isSuperAdmin ? (
                    <div className="action-buttons" style={{ display: 'flex', gap: '30px', justifyContent: 'center' }}>
                        <Button
                            onClick={handleCancel}
                            style={{
                                borderRadius: '6px',
                                padding: '5px 20px'
                            }}
                        >
                            OK
                        </Button>
                    </div>
                ) : (
                    <div className="action-buttons" style={{ display: 'flex', gap: '30px', justifyContent: 'center' }}>
                        <Button
                            onClick={handleCancel}
                            style={{
                                borderRadius: '6px',
                                padding: '5px 20px'
                            }}
                        >
                            Maybe Later
                        </Button>
                        <Button
                            type="primary"
                            onClick={handleUpgrade}
                            disabled={!isSuperAdmin}
                        >
                            {isStorageVariant ? 'Upgrade Storage' : 'Upgrade Now'}
                        </Button>
                    </div>
                )}

                {!isSuperAdmin ?
                    <div style={{ marginTop: 10, color: '#636363', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <div><InfoCircleOutlined /> Please contact your superadmin!</div>
                        <br />
                    </div>
                    : <></>}
            </div>

            <style jsx>{`
                .subscription-modal .ant-modal-content {
                    border-radius: 12px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                }
                
                .subscription-modal .lock-icon {
                    font-size: 48px;
                }

                .subscription-modal .ant-btn:hover {
                    opacity: 0.9;
                    transform: translateY(-1px);
                    transition: all 0.2s;
                }
            `}</style>
        </Modal>
    );
};

const mapStateToProps = (state) => {
    const { user } = state.session;
    return { user };
};


const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(AulasSubscriptionModal);